module.exports = __webpack_public_path__ + "static/media/calendar_icon.447bd2e5.svg";